/** Hospital / enterprise CRE sign-in (Entra CIAM). */
export const CRE_LOGIN_PATH = "/cre";

/** Extension-only CRE sign-in and handoff (public org users). */
export const CRE_EXTENSION_PATH = "/cre/extension";
